import React from 'react'
import { useParams } from "react-router-dom";
import App from './App';

const AppWrapper = ({apiBaseUrl}) => {  
    let params = useParams();
    return <App id={ params.zastupitelstvoId } apiBaseUrl={ apiBaseUrl } />
};

export default AppWrapper
